import productBaseMixin from '../../components/product/base-mixin';
import styleMixin from './style-mixin';
import { isMobile } from '@polyv/utils/src/browser';
import { BEFORE_DESTROY } from '@/assets/utils/compat';

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },

  mixins: [productBaseMixin, styleMixin],

  data() {
    return {
      good: undefined,
      // 气泡外层是否显示
      wrapVisible: false,
      // 气泡是否显示
      bubbleVisible: false,

      hotTimes: 0,

      lastHotTimes: 0,

      defaultTrackEvent: 'product_push_item_click',

      lastProductPushRule: 'smallCard',
    };
  },

  props: {
    // 气泡外层是否显示
    visible: {
      type: Boolean,
      default: false,
    }
  },

  watch: {
    productSdk: {
      immediate: true,
      handler() {
        this.listenSdkEvent();
      },
    },
    good: {
      handler(val, oldVal) {
        if (!oldVal || !val) return;
        if (val.productId !== oldVal.productId) {
          this.lastHotTimes = 0;
          this.$nextTick(() => {
            this.hotTimes = 0;
          });
        }
      },
      deep: true
    },
    hotTimes(val, oldVal) {
      if (oldVal) {
        this.lastHotTimes = oldVal;
      }
    },
  },

  [BEFORE_DESTROY]() {
    this.unlistenSdkEvent();
  },

  mounted() {
    this.wrapVisible = this.visible;
    this.getCurrentPushingProduct();
  },

  methods: {
    /** 监听 sdk 事件 */
    listenSdkEvent() {
      if (!this.productSdk) {
        return;
      }
      const { events } = this.productSdk;
      this.productSdk.on(events.PRODUCT_MESSAGE, this.handleProductMessage);
      this.productSdk.on(events.CloseProductBubble, this.close);
      this.productSdk.on(events.ProductClickTimes, this.handleProductClickTimesMsg);
      this.productSdk.on(events.RefreshProductList, this.handleRefreshProductList);
    },

    /** 取消监听 sdk 事件 */
    unlistenSdkEvent() {
      if (!this.productSdk) {
        return;
      }
      const { events } = this.productSdk;
      this.productSdk.off(events.PRODUCT_MESSAGE, this.handleProductMessage);
      this.productSdk.off(events.CloseProductBubble, this.close);
      this.productSdk.off(events.ProductClickTimes, this.handleProductClickTimesMsg);
    },

    /**
     * 处理商品库消息
     */
    handleProductMessage(msg) {
      if (!this.productSdk) {
        return;
      }

      this.lastProductPushRule = msg.content.productPushRule;

      const ProductMessageStatus = this.productSdk.ProductMessageStatus;
      const status = `${msg.status}`;

      if (status === ProductMessageStatus.PushProduct) {
        this.handleBubbleVisible(msg.content);
        return;
      }

      if (status === ProductMessageStatus.CancelPushProduct) {
        this.handleCancelPushProduct(msg.content);
        return;
      }

      switch (status) {
        case ProductMessageStatus.OnShelf:
          this.handleOnShelfProduct(msg.content);
          break;
        case ProductMessageStatus.OffShelf:
        case ProductMessageStatus.DeleteProduct:
          this.handleOffShelfAndDel(msg.content);
          break;
        case ProductMessageStatus.ChangeProduct:
          this.handleChangeProduct(msg.content);
          break;
        case ProductMessageStatus.MoveUp:
        case ProductMessageStatus.MoveDown:
          this.handleMoveProduct(msg.content);
          break;
        case ProductMessageStatus.ProductSoldOut:
          this.handleSoldOut(msg.content);
          break;
        default:
          break;
      }
    },

    // 在气泡中点击购买按钮用气泡的事件 id 发送
    getClickBuyTrackEventId() {
      return 'product_push_item_click';
    },

    /** 当前显示的气泡序号递增 */
    addNumber() {
      if (!this.good) return;
      this.$set(this.good, 'showId', this.good.showId + 1);
    },
    /** 当前显示的气泡序号递减 */
    reduceNumber() {
      if (!this.good) return;
      this.$set(this.good, 'showId', this.good.showId - 1);
    },

    // 操作1 - 上架商品
    handleOnShelfProduct(data) {
      if (!this.good) return;
      if (data.showId < this.good.showId) {
        this.addNumber();
      }
    },

    // 操作2 - 下架商品
    // 操作3 - 删除商品
    handleOffShelfAndDel(data) {
      if (!this.good) return;
      if (data.productId === this.good.productId) {
        this.close();
      }
      if (data.showId && data.showId < this.good.showId) {
        this.reduceNumber();
      }
    },

    // 操作5 - 编辑商品
    handleChangeProduct(data) {
      if (!this.good) return;
      if (data.productId === this.good.productId) {
        // remark 因为新增大卡片，而返回的新消息中不包含推送规则，因此更新信息时需要保持上一次的打开规则，否则切换为小卡片形式
        this.good = {
          ...data,
          productPushRule: this.good.productPushRule || 'smallCard'
        };
      }
    },

    // 操作6 - 上移商品
    // 操作7 - 下移商品
    handleMoveProduct(data) {
      if (!this.good) return;
      const findIndex = data.findIndex(
        item => item.productId === this.good.productId
      );
      if (findIndex === -1) {
        return;
      }
      // remark 与操作5同理
      this.good = {
        ...data[findIndex],
        productPushRule: this.good.productPushRule || 'smallCard'
      };
    },

    // 操作9 - 推送消息
    handleBubbleVisible(data) {
      this.$emit('product-push', data);
      this.good = { ...data };
      console.info('push', this.good);
      this.hotTimes = 0;
      this.wrapVisible = true;
      this.$nextTick(() => {
        this.bubbleVisible = true;
      });

      this.trackViewLog();
    },

    // 操作11 - 取消商品推送
    handleCancelPushProduct(data) {
      if (!this.good) return;
      this.hotTimes = 0;
      if (data.productId === this.good.productId) {
        this.close();
      }
    },

    // 操作12 - 商品售罄
    handleSoldOut(data) {
      const targetId = data.productId;
      if (!this.good || this.good.productId !== targetId) return;
      this.good = {
        ...this.good,
        stock: 0,
      };
    },

    async handleRefreshProductList() {
      const product = await this.productSdk.getCurrentPushingProduct();
      if (product) {
        this.good = {
          ...product,
          productPushRule: this.lastProductPushRule || product.pushRule || 'smallCard',
        };
      }
    },

    async getCurrentPushingProduct() {
      if (!this.productSdk) return;
      try {
        const product = await this.productSdk.getCurrentPushingProduct();
        if (product) {
          this.handleBubbleVisible({
            ...product,
            productPushRule: product.pushRule || 'smallCard',
          });
        }
      } catch (e) {}
    },

    trackViewLog() {
      if (!this.trackViewEnabled) {
        return;
      }

      const trackLogData = {
        event_cata: 'behavior',
        event_type: 'show',
        event_id: 'product_push_item_view',
        spec_attrs: {
          exposureTime: new Date().getTime(),
          linkType: isMobile() ? 'mobile' : 'pc',
          productId: this.good.productId,
        }
      };
      if (!this.good.logId) return;
      // 需要对齐线上商品库埋点字段 linkType
      if (this.good && this.good.logId) {
        trackLogData.spec_attrs.pushId = this.good.logId;
      }
      this.productSdk.trackLog(trackLogData);
    },

    close() {
      this.bubbleVisible = false;
    },

    handleAfterLeave() {
      this.wrapVisible = false;
      this.good = undefined;
    },
    clickProductCard() {
      const trackLogData = {
        event_cata: 'behavior',
        event_type: 'click',
        event_id: 'user_click_product_card_bubble',
        spec_attrs: Object.assign({
          clickTime: new Date().getTime(),
        }, this.good, { linkType: isMobile() ? 'mobile' : 'pc' })
      };
      if (!this.good.logId) return;
      // 需要对齐线上商品库埋点字段 linkType
      if (this.good && this.good.logId) {
        trackLogData.spec_attrs.pushId = this.good.logId;
      }
      this.productSdk.trackLog(trackLogData);
    },
    handleProductClickTimesMsg(res) {
      if (this.good && res.productId === this.good.productId) {
        this.hotTimes = res.times;
      }
    }
  }
};
